import {
  FaMapLocationDot,
  FaBookAtlas,
  TbZoomScan,
} from "@forestsync/ui"

export interface NavItem {
  id: string
  icon: any
  href: string
  disabled?: boolean
  color?: string
  external?: boolean
  fullWidth?: boolean
  spotlightTrigger?: boolean
}

export const platformNavItems: NavItem[] = [
  {
    id: "glassroom",
    icon: FaBookAtlas,
    href: "/glassroom",
    color: "blue",
  },
  {
    id: "forestsMap",
    icon: FaMapLocationDot,
    href: "/map",
    color: "green",
  },
  {
    id: "verify",
    icon: TbZoomScan,
    href: "/verify",
    color: "violet",
    fullWidth: true,
    spotlightTrigger: true,
  },
]
